<template>
  <div class="c-online-solutions">
    <h2 class="c-online-solutions__title">{{ $t('online.title') }}</h2>
    <div class="c-online-solutions__items" v-if="visibleMarkers.length">
      <StoreSummary v-for="marker in displayedMarkers" :marker="marker" :key="marker.id"/>
      <a class="c-online-solutions__more" @click="nextPage" v-if="visibleMarkers>displayedMarkers">{{ $t('search.more') }}</a>
    </div>
    <div class="c-online-solutions__items" v-else>
      <div class="c-search-results__message">{{ $t('search.online_error') }}</div>
      <a class="c-search-results__cta c-search-results__cta--search" v-track-button="{location:'search_results'}" @click="editSearch">{{ $t('search.edit') }}</a>
    </div>
  </div>
</template>

<script>
import StoreSummary from "@/components/StoreSummary.vue";
import {formatMarker, trackEvent} from "@/scripts/api";

export default {
  components: {
    StoreSummary
  },
  methods:{
    editSearch(){
      this.$router.push({name:'home'})
      this.emitter.emit('searchFocus');
    },
    nextPage() {
      this.$store.commit('page', {id:'online', page: this.page + 1 })
    },
    trackView(){

      if( this.displayedMarkers && this.displayedMarkers.length )
        trackEvent('view_online_solutions_list',{items: this.visibleMarkers.slice((this.page-1)*20, this.page*20).map(formatMarker)})
    },
  },
  watch:{
    displayedMarkers(oldValue, newValue){
      if( JSON.stringify(oldValue) !== JSON.stringify(newValue) )
        this.$nextTick(this.trackView)
    }
  },
  computed:{
    filteredMarkers(){
      return this.$store.state.filteredMarkers;
    },
    page(){
      return this.$store.state.page.online;
    },
    displayedMarkers(){
      return this.visibleMarkers.slice(0, this.page*20)
    },
    visibleMarkers(){
      return Object.values(this.filteredMarkers).filter(marker=>{
        return marker.correspondance || marker.typeEntiteLegale==='DIGITALE'
      })
    }
  },
  mounted() {
    this.trackView()
  }
}
</script>

<style lang="scss">
.c-online-solutions{
  display: flex; flex-flow: column; grid-gap: $space;
  &__items{
    display: flex; flex-flow: column; grid-gap: $space; padding-top: $space;
  }
  &__more{
    background: $c-white; padding: $space-xs; display: block; text-align: center; border-radius: $space; order: 99999;
    margin-top: $space; cursor: pointer;
  }
  &__title{ @extend %title-section }
  &__close{
    background: url("../assets/picto/close.svg") no-repeat center $c-white; border-radius: 50%;
    display: inline-block; width: 3rem; height: 3rem; background-size: 60%;
    position: absolute; right: $space-s; top: $space-s; cursor: pointer; z-index: 1;
  }
}
</style>
